import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const withdraw = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `withdraws`,
      method: 'get',
      authorization: true,
      params: args?.params,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/${args?.id}`,
      method: 'patch',
      authorization: true,
      params: args?.params,
      data: args?.data,
      config: {
        successMsg: 'Updated successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'transactions',
      method: 'get',
      data: args?.data,
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const verifyPayment = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'requests/verify-payment',
      method: 'post',
      data: args?.data,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `withdraws/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const refundStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/status/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default {
  list,
  update,
  withdraw,
  verifyPayment,
  updateStatus,
  refundStatus,
}
